







import { Vue, Component, Watch } from 'vue-property-decorator'
import { api } from '../api'
import { store } from '../../store'

@Component
export default class extends Vue {
  mounted() {
    this.$watch('$root.$i18n.locale', () => {
      const locale = this.$root.$i18n.locale
      const session = store.galaxyCruise.session
      if (session) {
        const axios = api.default
        axios.patch(`../api/v1/user`, {
          user: {
            locale,
          }
        })
      }
    })
  }
}
